<template>
<!--游戏区服 -->
  <transition name="fade">
    <div class="project" :style="{transform:is_ie}" v-drag>
      <div role="document">
        <div class="modal-content" >
          <div class="modal-header">         
            <span class="modal-title">游戏区服</span>
            <!-- <span class="modal-title">{{value}}</span> -->
            <span aria-hidden="true" class="modal-span" @click="close">&times;</span>  
          </div>
          <div class="modal-body" @scroll="table_cont">
            <div>
                <div class="parent-checkbox" v-for="(data,index) in list_data"  :key="index">
                    <label class="parent-label">分组: {{data.fld_group_id}}
                        <input class="parent-input" type="checkbox" :value="index" v-model="parent_checkbox" @change="parent_checkbox_list(index)">
                    </label>
                    <div class="child-checkbox" > 
                        <span v-for="(server,server_index) in data.fld_servers.split(';')" :key="server_index">
                            <label class="child-label">{{server}}
                                <input class="child-input" type="checkbox" :value="data.fld_group_id+'-'+server" v-model="child_checkbox" @change="child_checkbox_list(index)">
                            </label>
                        </span>
                        
                    </div>
                </div>

                
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default btn-default-close" data-dismiss="modal" @click="cancel_selection">{{cancel}}</button>
            <button type="button" class="btn btn-default-determine" @click="determine">{{confirm}}</button>
          </div>
          <!-- 加载状态 -->
          <!-- <div class="loading" v-if="anate"><i class="fa fa-spin fa-spinner"></i></div> -->
        </div>
      </div>
    </div>
     <!-- 提示组件 -->
	<tips v-if="sel_tips" :current_state="current_state" :language_pack="language_pack"></tips>
  </transition>
</template>
<script>
  import { mapState } from 'vuex';
  import api from "../api/index.js";
  import tips from "./tips.vue"
  export default {
    name: 'Project',
    components: {
      tips
    },
    computed:{
    //   head_title(){
    //     return '--'+this.$attrs.language_pack[this.sel_language].select_distribution_package+'--'
    //   },
      confirm(){
        return this.$attrs.language_pack[this.sel_language].confirm
      },
      cancel(){
        return this.$attrs.language_pack[this.sel_language].cancel
      },
     
      ...mapState({
        sel_language:'sel_language'
      })
    },
    watch: {
        // parent_checkbox:{
            // alert(0)
            // get(){return this.parent_checkbox_list},
            // set(val){
            //     alert(0)
            //     console.log(val)
            //     if(val.length>0){
            //         val.forEach((item,index)=>{
            //             this.list_data[item].fld_servers.split(';').forEach((item1,index1)=>{
            //                 // console.log(this.child_checkbox)
            //                 this.child_checkbox_list.push(item+'-'+index1)
            //             })
            //         })
            //     }else{
            //         console.log('adfs')
            //         this.child_checkbox_list=[]
            //     }
            // }
        // },
        // child_checkbox:{
        //     get(){console.log('this.child_checkbox');return this.child_checkbox_list},
        //     set(val){
        //         console.log(val)
        //     }
        // }, 

    },
    data(){
      return {
        //错误提是信息
        current_state:'',
        //是否显示提是组件
        sel_tips:false,
        //距离头部的位置
        tans_late:'',
        //加载状态
        // anate:true,
        //复选框的数组
        // check_data:[],
        //获取的弹框数据
        list_data:null,
        child_list_data:[],
        //总复选框
        parent_checkbox:[],
        //列表复选框
        child_checkbox:[],
        //复选框中的值
        checkbox_value:[],
        //单选按钮
        // list_radio:false,
        //头部数据
        // show_data:null,
        //计数
        // count:0,
        // head_data:[],
        // rows:null,
        //标题
        // value:'',
        //是否是ie
        is_ie:false,
        num:[0,1]
      }
    },
    mounted(){
    //获取数据
    this.get_data()
    //   this.get_data(this.key_s.Name);
    //   this.selected_data()
      //判断是不是ie
      this.t_ie()
      
    //   console.log(this.area_data)
    },
    props:[
      //有弹框的头部字段（根据此字段判断是否有弹框）
      'ppr_action',
      //有弹框的数据头部字段
      'ppr_action_param',
      //弹框中的函数
      'box_fun',
      //输入框中的值
      'rule_data',
      'key_s',
      'area_data'
    ],
    methods:{
        //当编辑或者有默认值的时候自动选中已有的值
        is_slect(){
            if(this.area_data){
                this.area_data.forEach((item,index)=>{
                    this.child_checkbox.push(item)
                })
                var data=[];
                this.child_checkbox.forEach((item)=>{
                  data.push(item.split('-')[0])
                })
                this.list_data.forEach((item,index)=>{
                
                        if(data.some((item1,index1)=>{return item1==item.fld_group_id})){
                            this.parent_checkbox.push(index)
                        }                    
                })
            }
            
        },
        //总复选框
        parent_checkbox_list(i){
            if(this.parent_checkbox.length>0){
                this.child_checkbox=[];
                this.parent_checkbox.forEach((item,index)=>{
                    this.list_data[item].fld_servers.split(';').forEach((item1,index1)=>{
                        this.child_checkbox.push(this.list_data[item].fld_group_id+'-'+item1)
                    })
                });
            }else{
                this.child_checkbox=[]
            }
        },
        //列表复选框
        child_checkbox_list(i){
            var data=[];
            this.child_checkbox.forEach((item)=>{
              data.push(item.split('-')[0])
            })
            var sum=data.some((item,index)=>{return item==this.list_data[i].fld_group_id})
            if(sum){
                this.parent_checkbox.push(i)
            }else{
                this.parent_checkbox=this.parent_checkbox.filter((item,index)=>{//如果选中项中有与之相同的那么移除此项
                    return i!=item;						
				});
            }
        },
      //获取数据
      async get_data(){
          let res= await this.async_error(api.getTableHead('/Sandbox/Launcher/tbl_server_group',window.sessionStorage.getItem('userInfo')))
        //   this.head_data=res.data.FIELDS;
          let para={};
          para.userInfo=window.sessionStorage.getItem('userInfo');
          let res1= await this.async_error(api.getBoxData(res.data,para))
          this.list_data=res1.data;
          res1.data.forEach((item,index)=>{
            this.child_list_data.push(item.fld_servers);
          })
          this.checkbox_value=this.child_list_data.join(';').split(';');
          this.is_slect()
      },
      t_ie(){
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          // this.is_ie='translate(-50%, -50%)'
        }
      },
      //捕获异步错误
	  async_error(promise){
	  	return promise.then(res => res).catch(error => this.error_message(error));
	  },
      //错误提示
	  error_message(message){
				this.sel_tips=true;
				this.current_state=message;
				window.setTimeout(()=>{
					this.sel_tips=false;
				},2000)
				this.anate=false;
	  },
      //固定表头
      table_cont(e){
				this.tans_late=e.target.scrollTop;
		  },
      //点击关闭图标
      close(){
        this.$emit('close_project')
      },
      //点击取消
      cancel_selection(){
        this.child_checkbox=[];
        this.parent_checkbox=[];
      },
      //点击确定
      determine(){
          var data=[];
          var data_backup=[];
          this.child_checkbox.forEach((item)=>{
              data_backup.push(item);
              data.push(item.split('-')[1]);
          })       
          data=data.join(',').replace(/\,/g,';');
          this.$emit('data_backup',data_backup);
        this.$emit('input_data',data) 
     },
    },
    directives: {
      drag: {
        inserted(el) {
          let drag_Box = el; //获取当前元素
          let dragBox = document.getElementsByClassName('modal-header')[0];
          dragBox.onmousedown = e => {
              //算出鼠标相对元素的位置
              let disX = e.clientX - drag_Box.offsetLeft;
              let disY = e.clientY - drag_Box.offsetTop;
              document.onmousemove = e => {
                console.log(1)
                  //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                  let left = e.clientX - disX;
                  let top = e.clientY - disY;
                  //移动当前元素
                  drag_Box.style.left = left + "px";
                  drag_Box.style.top = top + "px";
              };
              document.onmouseup = e => {
                    //鼠标弹起来的时候不再移动
                    document.onmousemove = null;
                   //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
                  document.onmouseup = null;
              };
          };
        }
      }
    }
  }
</script>
<style scoped>
    .parent-checkbox{
        margin-top: 10px;
        font-size: 18px;
        color: #007bff;
    }
    .parent-input{
        width: 20px;
        height: 20px;
        margin-left: 10px;
        vertical-align: middle;
    }
    .parent-label{
        margin-left: 10px;
    }
    .child-checkbox{
        margin-left: 30px;
    }
    .child-label{
        margin-left: 10px;
    }
    .child-input{
        margin-left: 10px;
    }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .fa-spin{
	    -webkit-animation: fa-spin 1s infinite linear;
      animation: fa-spin 1s infinite linear;
	}
  .modal-footer{
    justify-content: space-between;
  }
	.loading{
		z-index: 1000;
		font-size: 50px;
		position: absolute;
		color: rgb(138, 132, 132);
		top: 50%;
		left: 50%;
		/* transform: translate(-50%, -50%); */
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px));
		text-align: center;
	}
  .modal-header{
    cursor: move;
  }
  .modal-body{
    max-height: 500px;
    overflow: auto;
    padding-top: 0;
  }
	.project{
    min-width: 846px;
    position: fixed;
    top: 50%;
    left: 50%;
    height: 500px;
    z-index:999;
    transform: translate(-50%, -50%);
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  /* transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px)); */
  }
 .modal-header{
		background:#ebecf0;
		height:40px
	}
 .modal-span{
		font-size:20px;
		margin-top:-14px;
		cursor:pointer
	}
	.modal-title{
		line-height:1px
	}
  .btn-default-close{
    color:#007bff;
		font-size:12px;
		border:1px solid #808080;
		padding:4px;
		/* margin-right: 90%; */
  }
  .btn-default-determine{
    color:#007bff;
		font-size:12px;
		border: 1px solid rgb(128, 128, 128);
		padding: 4px;
  }
</style>